export default __webpack_public_path__ + "static/media/myanmar.5f575294.png";